import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import * as v3Adapter from "./adapter/v3";
import { secureConnectionQueryOptions } from "./api/secure-connection-query-options";

// Auto-paginating view — only use when the consumer actually needs the complete share list
// (e.g. save-diff correctness in SendingShareDialog). Existence / small-set callers should use
// useSendingShareExistence instead.
export function useSendingShares(resourceId: string | undefined) {
  const query = useInfiniteQuery({
    ...secureConnectionQueryOptions.sharesForResourceInfinite(resourceId),
    select: (data) => data.pages.flatMap((page) => page.items.map(v3Adapter.toConnectionShare)),
  });

  const { hasNextPage, isFetchingNextPage, fetchNextPage, isError } = query;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage && !isError) {
      void fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, isError, fetchNextPage]);

  return query;
}
